import { defineMessages } from 'react-intl';

export const text = defineMessages({
  helpContent1: {
    id: 'agentChat.helpContent1',
    defaultMessage:
      'Welcome to Zori AI Chat. Zori AI Chat is an artificial intelligence (“AI”) system built with a large language model that will help assist in reviewing subject data.',
  },
  helpContent2: {
    id: 'agentChat.helpContent2',
    defaultMessage:
      'Zori AI Chat cannot contact emergency services. If you or a subject are experiencing a medical emergency, please call 9-1-1 immediately for assistance.',
  },
  helpContent3: {
    id: 'agentChat.helpContent3',
    defaultMessage:
      "Zori AI Chat has access to the subject's medical data, including test results and medical diagnoses, visit notes, etc, and is intended to answer basic questions and provide general information. While we strive to deliver accurate and reliable information, Zori AI Chat is still learning and may not always be completely accurate.",
  },
  helpContent4: {
    id: 'agentChat.helpContent4',
    defaultMessage:
      'Providing feedback on the accuracy of Zori AI’s responses will help improve the system. If you have feedback, please provide it with as much detail as possible.',
  },
  startingMessage: {
    id: 'agentChat.startingMessage',
    defaultMessage: 'This is the beginning of the chat.',
  },
  noMemberHistory: {
    id: 'agentChat.noMemberHistory',
    defaultMessage: 'No chat history',
  },
});
